import { UIComponentProps, UIComponentHandler, UIComponentImpl, UIComponentState } from '../../../toolkit/uicomponent';
import { ToneDto } from '../../../../core/dto/tonedto';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { GiftAFriendViewImpl } from './giftafriendview';
import { GiftAFriendCSSStyleImpl } from './giftafriendcss';
import { GiftAFriendAPIModelImpl, GiftAFriendAPIModel } from './giftafriendapimodel';
import { GiftToneDto } from '../../../../core/dto/gifttone/gifttonedto';
import { ToneOptionsType } from '../tonedetailspopup/tonedetailspopupcomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { GetPackDetails } from '../getpackdetails';
import { GetTonePriceDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/gettoneprice/gettonepricedetailsdto';

export interface GiftAFriendComponentProps extends UIComponentProps
{
    toneOptionsType: ToneOptionsType;
    toneDto: ToneDto;
    closePopup(): void;
    showPopup(id:string,msg:string,type:AlertType):void;
}

export interface GiftAFriendComponentState extends UIComponentState
{
    isPrice: boolean;
    price:string;
    msisdn: string;
    packName: string;
}
export interface GiftAFriendComponentHandler extends UIComponentHandler
{
    onConfirmClick(): void;
    onValidateClick(): void;
}

export class GiftAFriendComponent extends UIComponentImpl<GiftAFriendComponentProps, GiftAFriendComponentState, GiftToneDto> 
implements GiftAFriendComponentHandler
{
    constructor(props: GiftAFriendComponentProps, state:GiftAFriendComponentState)
    {
        super(props);
        this.state={packName: '',
        price:this.getContext().getResources().getString(Strings.gift_default_value), isPrice: false, msisdn: ""};
    }

    componentWillUnmount()
    {
        document.removeEventListener("keydown",()=>'');
    }
    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();
        
        // (this.getAPIModel() as GiftAFriendAPIModel).getTonePrice(this.props.toneDto);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<GiftToneDto>
    {
        return new GiftAFriendViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new GiftAFriendCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new GiftAFriendAPIModelImpl(applicationContext, apiModelHandler);
    }

    onValidateClick(): void 
    {
        if(this.getView().validate())
        {   
            (this.getView() as GiftAFriendViewImpl).showLoader();  
            (this.getAPIModel() as GiftAFriendAPIModel).getTonePrice(this.props.toneDto, 
                (this.getView() as GiftAFriendViewImpl).getData().getMsisdnB());

        }
    }

    onConfirmClick(): void 
    {
        (this.getView() as GiftAFriendViewImpl).showLoader();  
        (this.getAPIModel() as GiftAFriendAPIModel).giftAFriend((this.getView() as GiftAFriendViewImpl).getData());
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as GiftAFriendViewImpl).dismissLoader();  
        if(feature === APIFeatures.GET_TONE_PRICE)
        {
            let packDetails = this.props.context.getConfigurationSettings().getPropertyBasedOnLanguage("VALIDITY");
            
            console.log("packdetails: " + packDetails);
            let PRICE_TEXT: string = new GetPackDetails(packDetails)
            .getPrice((data as GetTonePriceDetailsDto).getPackName(),
             this.props.toneDto.getPrice());

             console.log("PRICE_TEXT: " + PRICE_TEXT);
             this.setState({price:PRICE_TEXT,msisdn: description, 
                packName: (data as GetTonePriceDetailsDto).getPackName(),
                  isPrice: true});

        }
        else if(feature === APIFeatures.GIFT_TONE)
        {
            this.props.showPopup(this.props.context.getResources().getString(Strings.gift_a_friend),this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),AlertType.SUCCESS);
        }
        else
        {
            // this.props.onFailure();   
        }  
    }
    
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as GiftAFriendViewImpl).dismissLoader();  
        if(feature === APIFeatures.GIFT_TONE)
        {
            this.props.showPopup(this.props.context.getResources().getString(Strings.gift_a_friend),description,AlertType.ERROR);
        }
        else if(feature === APIFeatures.SUBSCRIBER_VALIDATION)
        {
            this.props.showPopup(this.props.context.getResources().getString(Strings.gift_a_friend),description,AlertType.WARN);

        }
        else
        {
            this.props.showPopup(this.props.context.getResources().getString(Strings.gift_a_friend),description,AlertType.ERROR);

        }

    
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/giftafriend/giftafriendcomponent.tsx